import { j as i } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as d } from "../../../node_modules/clsx/dist/clsx.m.js";
import g from "../../../node_modules/lodash/startCase.js";
import e from "../../../node_modules/lodash/replace.js";
import { memo as f, forwardRef as y } from "react";
import o from "./Typography.module.scss.js";
const u = f(
  y(
    ({
      text: r,
      className: t,
      variant: a = "body-new/regular",
      textColor: n = "color/fg/bold",
      testId: p,
      ...m
    }, s) => {
      const l = `typography-${typeof window < "u" && (document == null ? void 0 : document.documentElement.lang) || "en"}-${e(
        a,
        new RegExp("/", "g"),
        "-"
      )}`.replace("-new", ""), c = `color${e(g(n), new RegExp(" ", "g"), "")}`;
      return /* @__PURE__ */ i.jsx(
        "p",
        {
          className: d(
            o.typographyContainer,
            o[l],
            o[c],
            t
          ),
          "data-testid": p,
          ...m,
          ref: s,
          children: r
        }
      );
    }
  )
);
u.displayName = "Typography";
export {
  u as Typography,
  u as default
};
//# sourceMappingURL=Typography.js.map
